<template>
    <div class="roma-page-content fill-height">
        <v-container class="form-new-lesson">
            <template>
                <!-- Label -->
                <v-row class="justify-space-between align-center" no-gutters>
                    <v-col cols="auto">
                        <h2 class="form-new-lesson__title d-flex align-center">
                            <template v-if="updateItem">
                                <img
                                    src="@/assets/icons/create-class-icon.svg"
                                    class="form-icon"
                                    alt=""
                                />
                                <span class="ml-2">Editar clase</span>
                            </template>
                            <template v-else>
                                <img
                                    src="@/assets/icons/create-class-icon.svg"
                                    class="form-icon"
                                    alt=""
                                />
                                <!-- <v-icon>icon-edit-class</v-icon> -->
                                <span class="ml-2">Crea tu clase</span>
                            </template>
                        </h2>
                    </v-col>
                    <v-col cols="auto" class="d-flex justify-end">
                        <v-btn
                            color="white"
                            fab
                            class="close-btn"
                            @click="goBack()"
                            small
                        >
                            <img src="@/assets/images/close.svg" alt="" />
                            <!-- <v-icon color="red">mdi-close</v-icon> -->
                        </v-btn>
                    </v-col>
                </v-row>

                <!-- General Information -->
                <v-row class="align-baseline">
                    <v-col cols="12" sm="">
                        <v-text-field
                            dense
                            name="classTitle"
                            label="Título"
                            :rules="requiredRules"
                            outlined
                            rounded
                            id="title"
                            :maxlength="150"
                            v-model="title"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            dense
                            name="classCode"
                            label="Código"
                            :maxlength="20"
                            :rules="requiredRules"
                            outlined
                            rounded
                            id="id"
                            v-model="code"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="auto" class="">
                        <v-checkbox
                            label="Pie"
                            v-model="pie"
                            :value="pie"
                            class="mt-0 pie-check"
                        ></v-checkbox>
                    </v-col>
                </v-row>

                <!-- Description -->
                <v-row class="mb-5">
                    <v-col cols="12">
                        <TipTap
                            placeholder="Descripcion"
                            :data="setDescription"
                            :updateMode="{
                                status: $route.params.id ? true : false,
                                currentSelected: $route.params.id
                                    ? getLesson.description
                                    : ''
                            }"
                        />
                    </v-col>
                    <v-col cols="12" v-if="editorIsEmpty">
                        <div
                            class="v-messages theme--light error--text"
                            role="alert"
                        >
                            <div class="v-messages__wrapper">
                                <div class="v-messages__message">
                                    Este campo es requerido
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>

                <!-- Subjects and level -->
                <v-row v-if="!!Object.keys(lessonInfo).length">
                    <!-- subject -->
                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            dense
                            v-model="subject"
                            :items="lessonInfo.subjectList"
                            label="Asignatura"
                            outlined
                            rounded
                            :rules="requiredRules"
                            :item-text="
                                item => capitalizeFirstLetter(item.name)
                            "
                            :item-value="item => item.name"
                        ></v-select>
                    </v-col>

                    <!-- level -->
                    <v-col cols="12" sm="6" md="3">
                        <GroupSelect
                            :items="currentSubject"
                            placeholder="Nivel"
                            :setData="setNivel"
                            :required="true"
                            :updateMode="{
                                status: $route.params.id ? true : false,
                                currentSelected: $route.params.id
                                    ? getLesson.category.categoryId
                                    : ''
                            }"
                        />
                    </v-col>

                    <!-- cource -->
                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            dense
                            v-model="cource"
                            :items="this.sectionsItems"
                            label="Curso"
                            outlined
                            rounded
                            :rules="requiredRules"
                            :item-text="item => item.nameAndCategoryName"
                            :item-value="item => item.sectionId"
                        ></v-select>
                    </v-col>

                    <!-- unit -->
                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            dense
                            v-model="unit"
                            :items="lessonInfo.unitList"
                            label="Unidad"
                            outlined
                            rounded
                            :rules="requiredRules"
                            :item-text="
                                item => capitalizeFirstLetter(item.name)
                            "
                            :item-value="item => item.unitId"
                        ></v-select>
                    </v-col>
                </v-row>

                <!-- Planification -->
                <v-row
                    class="py-0 my-0"
                    v-if="!!Object.keys(lessonInfo).length"
                >
                    <!-- plan de unidad -->
                    <v-col cols="12" sm="6" md="4">
                        <v-select
                            dense
                            v-model="planUnit"
                            :items="getPlanUnits"
                            :item-text="item => item.nombre"
                            :item-value="item => item.id"
                            label="Plan de Unidad"
                            outlined
                            rounded
                        ></v-select>
                    </v-col>
                    <!-- actividad -->
                    <v-col cols="12" sm="6" md="4">
                        <v-select
                            dense
                            v-model="activity"
                            :items="getPlanUnitActivities"
                            :item-text="item => item.titulo"
                            :item-value="item => item.id"
                            label="Actividad"
                            outlined
                            rounded
                        ></v-select>
                    </v-col>
                    <!-- semana -->
                    <v-col cols="12" sm="6" md="4">
                        <v-select
                            dense
                            v-model="week"
                            :items="getWeeks"
                            :item-text="
                                item =>
                                    item.iniDia +
                                    ' - ' +
                                    item.finDia +
                                    ' ( ' +
                                    item.mes +
                                    ' )'
                            "
                            :item-value="item => item.id"
                            label="Semana"
                            outlined
                            rounded
                        ></v-select>
                    </v-col>
                </v-row>

                <!-- submit -->
                <v-row class="justify-center">
                    <v-btn
                        rounded
                        color="accent"
                        large
                        :disabled="
                            $route.params.id ? avalibleUpdate : !availableSubmit
                        "
                        class="roma-btn"
                        @click="goToAction()"
                    >
                        <span class="text-capitalize mr-4">Guardar</span>
                        <v-icon>icon-save-white</v-icon>
                    </v-btn>
                </v-row>
            </template>
        </v-container>
    </div>
</template>

<script>
import TipTap from "@/components/commons/RomaTipTap";
import GroupSelect from "@/components/commons/RomaGroupSelect";
import { mapActions, mapGetters } from "vuex";
export default {
    props: ["updateItem"],
    components: { TipTap, GroupSelect },
    data() {
        return {
            title: "",
            code: "",
            pie: false,
            description: ``,
            subject: "",
            level: "",
            cource: "",
            unit: "",
            planUnit: "",
            activity: "",
            week: "",
            dialog: false,

            sectionsItems: [],

            // validations
            requiredRules: [v => !!v || "Este campo es requerido"],
            editorIsEmpty: false
        };
    },
    async mounted() {
        this.updateItem
            ? await this.actionGetLesson(this.updateItem)
            : this.resetLessonUpdate();

        await this.actionGetInformationLesson(this.getInstitutionId);
        this.$route.params.id ? this.updateMode(this.getLesson) : false;
    },
    computed: {
        ...mapGetters({
            user: "getUserData",
            lessonInfo: "getLessonInformation",
            getLessons: "getLessons",
            getInstitutionId: "getInstitutionId",
            getLesson: "getLesson",
            getPlanUnits: "getPlanUnits",
            getPlanUnitActivities: "getPlanUnitActivities",
            getWeeks: "getWeeks"
        }),
        currentSubject() {
            const subjectList = this.lessonInfo.subjectList
                ? this.lessonInfo.subjectList
                : [];
            const currentSubject = subjectList.filter(subject => {
                return subject.name === this.subject;
            });
            return currentSubject;
        },
        currentEducations() {
            const educations = this.currentSubject[0]
                ? this.currentSubject[0].educations
                : [];

            // deconstruct Educations
            const newArr = [];
            educations.forEach(item => {
                newArr.push({
                    header: item.name
                });
                item.categories.forEach(category => {
                    newArr.push(category);
                });
                newArr.push({ divider: true });
            });
            return newArr;
        },
        availableSubmit() {
            const availableSubmit =
                !!this.title &&
                !!this.code &&
                !!this.description &&
                !!this.subject &&
                !!this.level &&
                !!this.cource &&
                !!this.unit;

            // &&
            // !!this.planUnit &&
            // !!this.activity &&
            // !!this.week;

            return availableSubmit;
        },
        avalibleUpdate() {
            const avalibleUpdate =
                this.title === this.getLesson.title &&
                this.code === this.getLesson.code &&
                this.description === "" &&
                this.level === "" &&
                this.cource === this.getLesson.section.sectionId &&
                this.subject === this.getLesson.subject.name &&
                this.unit === this.getLesson.unit.unitId;
            return avalibleUpdate;
        },
        currentSubjectList() {
            return this.lessonInfo ? this.lessonInfo.subjectList : [];
        },
        currentInstitutionId() {
            return this.user && this.user.institutionContext
                ? this.user.institutionContext.institutionId
                : [];
        }
    },
    watch: {
        subject() {
            if(this.unit) {
                // this.planUnit ? this.planUnit = "" : '';
                
                this.actionGetPlanUnits({idUnidad: this.unit, idAsignatura: this.currentSubject[0].subjectId});
            }
        },
        unit(newValue, oldValue) {
            // this.planUnit = "";
            this.actionGetPlanUnits({idUnidad: newValue, idAsignatura: this.currentSubject[0].subjectId});
        },

        planUnit(newValue, oldValue) {
            // console.log(newValue);
            this.actionGetPlanUnitActivities(newValue);
            this.actionGetWeeks(newValue);
        },

        level: function() {
            // se limpia select cource
            if (!this.$route.params.id) {
                this.cource = null;
            }

            // AUXILIAR NIVEL EDUCATIVO

            let aux = 0;

            // Niveles de eduacion (Basico / Medio)
            this.currentSubject[0].educations.forEach(educationLevel => {
                // Niveles (1ero, 2do, 3ro, ...)
                const grado = educationLevel.categories.findIndex(
                    level => level.categoryId == this.level
                );

                if (grado != -1) {
                    aux = this.currentSubject[0].educations.findIndex(
                        element => element == educationLevel
                    );
                }
            });

            const categories = this.currentSubject[0].educations[aux].categories
                ? this.currentSubject[0].educations[aux].categories
                : [];

            const index = categories.findIndex(
                categoria => categoria.categoryId == this.level
            );

            const cursos = categories[index].sections;

            this.sectionsItems = cursos;
        }
    },
    methods: {
        goToAction() {
            this.$route.params.id
                ? this.updateLesson()
                : this.createNewLesson();
        },
        ...mapActions({
            actionGetInformationLesson: "actionGetInformationLesson",
            addNewLesson: "addNewLesson",
            actionToggleModal: "actionToggleModal",
            toastSuccess: "toastSuccess",
            toastError: "toastError",
            actionGetLesson: "actionGetLesson",
            resetLessonUpdate: "resetLessonUpdate",
            actionUpdateLesson: "actionUpdateLesson",
            actionGetPlanUnits: "actionGetPlanUnits",
            actionGetPlanUnitActivities: "actionGetPlanUnitActivities",
            actionGetWeeks: "actionGetWeeks"
        }),
        setNivel(level) {
            this.level = level;
        },
        setDescription(description) {
            this.description = description;
        },
        isEmpty() {
            this.editorIsEmpty =
                (this.description === "") | (this.description === "<p></p>")
                    ? true
                    : false;
        },
        createNewLesson() {
            const newLesson = {
                categoryId: this.level,
                code: this.code,
                courseId: this.cource,
                description: this.description,
                institutionId: this.user.institutionContext.institutionId,
                lessonId: 0,
                periodId: 0,
                personId: this.user.personId,
                sectionId: this.cource,
                subjectId: this.currentSubject[0].subjectId,
                title: this.title,
                unitId: this.unit,
                pie: this.pie,
                planUnitId: this.planUnit,
                planUnitActivityId: this.activity,
                planUnitWeekId: this.week
            };
            console.info(newLesson);

            this.addNewLesson(newLesson)
                .then(() => {
                    this.toastSuccess({
                        message: `Se creo la clase "${this.code} ${this.title}"`
                    });
                    this.$router.push({ name: "Lesson" });
                })
                .catch(err => {
                    console.info("error", err);
                });
        },
        updateLesson() {
            const updatedLesson = {
                title: this.title,
                code: this.code,
                subjectId: this.currentSubject[0].subjectId,
                courseId: this.cource,
                unitId: this.unit,
                pie: this.pie,
                categoryId: this.level
                    ? this.level
                    : this.getLesson.category.categoryId,
                description: this.description
                    ? this.description
                    : this.getLesson.description,
                lessonId: Number(this.$route.params.id),
                institutionId: this.currentInstitutionId,
                personId: this.user.personId,
                sectionId: this.cource, //??
                periodId: this.user.institutionContext.yearSelected, //??
                planUnitId: this.planUnit,
                planUnitActivityId: this.activity,
                planUnitWeekId: this.week
            };
            // console.info("To Update", updatedLesson);
            this.actionUpdateLesson(updatedLesson)
                .then(() => {
                    this.toastSuccess({
                        message: `Se Guardo la clase "${this.code} ${this.title}"`
                    });
                    this.$router.push({ name: "Lesson" });
                })
                .catch(() => {
                    this.toastSuccess({
                        message: `Se Guardo la clase "${this.code} ${this.title}"`
                    });
                });
        },
        toggleModal() {
            this.dialog = !this.dialog;
        },
        updateMode(data) {
            if (data) {
                // para llenar secciones (con observador)
                this.level = data.category.categoryId;

                console.info("DATA => ", data);

                this.title = data.title;
                this.code = data.code;
                this.subject = data.subject.name; //subject
                this.cource = data.section.sectionId; //cource
                this.unit = data.unit.unitId; //unit
                this.planUnit = data.planUnitId;
                this.activity = data.planUnitActivityId;
                this.week = data.planUnitWeekId;
            }
        }
    }
};
</script>

<style lang="scss">
.form-new-lesson {
    background-color: white;
    max-width: 1123px;
    .pie-check {
        .v-messages {
            display: none;
        }
    }
    &__subtitle {
        font-size: 19px;
        color: #262626;
    }
    &__title {
        font-size: 35px;
        color: #101010;
    }
    @media (min-width: 1904px) {
        &__title {
            font-size: 36px;
        }
    }
    @media (min-width: 1264px) and (max-width: 1903px) {
        &__title {
            font-size: 31px;
        }
    }
    @media (min-width: 960px) and (max-width: 1263px) {
        &__title {
            font-size: 25px;
        }
    }
    @media (min-width: 600px) and (max-width: 959px) {
    }
    @media (max-width: 599px) {
        &__title {
            font-size: 17px;
        }
        .form-icon {
            width: 17px;
            height: auto;
        }
        &__subtitle {
            font-size: 12px;
        }
        input[name="classTitle"] {
            font-size: 10px;
        }
        .v-select__selections {
            // background-color: #bada55;
            // font-size: 10px !important;
        }
    }
}
</style>
